// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { CSSProperties, Component } from 'react';
import { CSSTransition } from 'react-transition-group';

import { S } from './styles';

interface Props {
  children?: React.ReactNode;
  showDialog: boolean;
  boxStyle?: CSSProperties;
}

export default class Dialog extends Component<Props> {
  render() {
    const { children, showDialog, boxStyle } = this.props;
    const nodeRef = React.createRef<HTMLDivElement>();

    return (
      <CSSTransition in={showDialog} timeout={5} nodeRef={nodeRef}>
        <S.Container data-testid="dialog" ref={nodeRef}>
          <S.Box style={boxStyle} hasChildren={children !== null}>
            {children}
          </S.Box>
        </S.Container>
      </CSSTransition>
    );
  }
}
